import {cpsRepository} from '@/repositories/Index';


class CpsService {
    // 预测提升流量查询
    async predictBoostTrafficListFn(params: any) {
      const res = await cpsRepository.predictBoostTrafficList(params);
      return res;
    }
    
    //查询策略提升配置列表
    async upgradePolicyListFn() {
        const res = await cpsRepository.upgradePolicyList();
        return res;
    }
    
    //推广列表
    async myCpsListFn(params: any) {
        const res = await cpsRepository.myCpsList(params);
        return res;
    }

    //创建
    async createPlusFn(params: any) {
        const res = await cpsRepository.createPlus(params);
        return res;
    }
    
    //推广详情
    async cpsQueryInfoFn(params: any) {
        const res = await cpsRepository.cpsQueryInfo(params);
        return res;
    }

    //推广详情取消确认
    async hotelConfirmFn(params: any) {
        const res = await cpsRepository.hotelConfirm(params);
        return res;
    }
    
  
    //创建留资信息
    async saveRetainedCapital(params: any) {
        const res = await cpsRepository.saveRetainedCapital(params);
        return res;
    }
      
      

    //财务结算列表
    async settlementListFn(params: any) {
        const res = await cpsRepository.settlementList(params);
        return res;
    }

    //财务结算信息
    async settlementReviewProcessFn(params: any) {
        const res = await cpsRepository.settlementReviewProcess(params);
        return res;
    }   

    //财务结算上传发票信息
    async uploadInvoiceFn(params: any) {
        const res = await cpsRepository.uploadInvoice(params);
        return res;
    }   

    //财务结算发票日志
    async getInvoiceLogListFn(params: any) {
        const res = await cpsRepository.getInvoiceLogList(params);
        return res;
    }   
    //财务结算明细
    async settlementDetailFn(params: any) {
        const res = await cpsRepository.settlementDetail(params);
        return res;
    }  

    //生意金账单记录列表
    async settlementRechargeListFn(params: any) {
        const res = await cpsRepository.settlementRechargeList(params);
        return res;
    } 
    //生意金状态
    async checkHaveFipSaleRoomFn() {
        const res = await cpsRepository.checkHaveFipSaleRoom();
        return res;
    } 
    

  }
  
  export default CpsService;
  